// See user roles in app/models/concerns/user/role_assignable.rb
export const ADMIN_ROLE = "admin"
export const NON_ADMIN_ROLE = "non_admin"
export const PHP_ADMIN_ROLE = "php_admin"
export const SUBMITTER_ROLE = "submitter"

export const ORGANIZATION_ROLES = [
  SUBMITTER_ROLE,
  NON_ADMIN_ROLE,
  ADMIN_ROLE,
]

export const ACTIVITY_HUB_ORGANIZATION_ROLES = [
  NON_ADMIN_ROLE,
  ADMIN_ROLE,
]

export const READABLE_ROLE_NAMES = {
  [SUBMITTER_ROLE]: "Submitter",
  [NON_ADMIN_ROLE]: "Non Admin",
  [ADMIN_ROLE]: "Admin",
}

// User types identify a group of an organization's users by role.
// They are not roles themselves; they are the values stored in the
// userTypes attribute of a users-type question, which determines
// which of an organization's users may be selected as an answer.
export const ACTIVITY_HUB_USER_TYPE = "activityHub"
export const SUBMITTER_USER_TYPE = "submitter"

export const READABLE_USER_TYPE_NAMES = {
  [ACTIVITY_HUB_USER_TYPE]: "Activity Hub Users",
  [SUBMITTER_USER_TYPE]: "Submitters",
}
